import React from 'react';
import styles from './RouteForm.module.scss';

import Icon from './Icon';
import Badge, { BadgeSizes, BadgeStyles } from './Badge';
import { TRAVEL_MODES } from '../utils/Constants';
import SearchFormAddressBar from './SearchFormAddressBar';
import { useDeviceDetection } from '../utils/DeviceDetection';
import FloatingToggleButton from './FloatingToggleButton';

export default function RouteForm({
	travelMode,
	setTravelMode,
	result,
	calcRouteResponse,
	searchParameters,
	onSubmit,
	onCalcRouteClose,
	onOpenSidebarFocusInputRef
}) {
	const isMobile = useDeviceDetection();
	const [startInputValue, setStartInputValue] = React.useState(
		searchParameters?.formattedAddress
	);
	const [endInputValue, setEndInputValue] = React.useState(
		result?.formattedAddress
	);
	const [startAddress, setStartAddress] = React.useState(searchParameters);
	const [endAddress, setEndAddress] = React.useState({
		lat: result.lat,
		lng: result.lng,
		formattedAddress: result.formattedAddress
	});

	const showTravelMode = (travelMode) => {
		if (calcRouteResponse && calcRouteResponse[travelMode]) {
			calcRouteResponse[travelMode].show();
		}
		setTravelMode(travelMode);
	};

	const getTravelDuration = (travelMode) => {
		if (calcRouteResponse && calcRouteResponse[travelMode]) {
			return calcRouteResponse[travelMode].duration;
		} else {
			return 'ND';
		}
	};

	let isFirstStart = true;
	const handleStartInputChange = (event, nextInputValue) => {
		if (isFirstStart && !nextInputValue) {
			setStartInputValue(searchParameters?.formattedAddress);
			isFirstStart = false;
		} else {
			setStartInputValue(nextInputValue);
		}
	};

	let isFirstEnd = true;
	const handleEndInputChange = (event, nextInputValue) => {
		if (isFirstEnd && !nextInputValue) {
			setEndInputValue(result?.formattedAddress);
			isFirstEnd = false;
		} else {
			setEndInputValue(nextInputValue);
		}
	};

	const onStartSubmit = ({ lat, lng, formattedAddress }) => {
		setStartAddress({ lat, lng, formattedAddress });
		onSubmit({
			startFormattedAddress: formattedAddress,
			endLat: null,
			endLng: null
		});
	};

	const onEndSubmit = ({ lat, lng, formattedAddress }) => {
		setEndAddress({ lat, lng, formattedAddress });
		onSubmit({
			startFormattedAddress: null,
			endLat: lat,
			endLng: lng
		});
	};

	const swapStartEndAddress = () => {
		onSubmit({
			startFormattedAddress: endAddress.formattedAddress,
			endLat: startAddress.lat,
			endLng: startAddress.lng
		});
		const tmpAddress = startAddress;
		const tmpInputValue = startInputValue;

		setStartAddress(endAddress);
		setEndAddress(tmpAddress);

		setStartInputValue(endInputValue);
		setEndInputValue(tmpInputValue);
	};

	return (
		<div className={styles.routeForm}>
			<div>
				<Icon
					className={styles.middle}
					textOn="right"
					icon="icon/geolocator_white.png"
					size="small"
				/>
				<SearchFormAddressBar
					rootClassName={styles.inputContainer}
					className={styles.input}
					type="text"
					placeholder="Inserisci una posizione"
					inputValue={startInputValue}
					value={startInputValue}
					onInputChange={handleStartInputChange}
					onSubmit={onStartSubmit}
					focusOnMount={true}
				/>
			</div>
			<div>
				<Icon
					className={styles.middle}
					textOn="right"
					icon="pin/pin_subagenzie.png"
					size="small"
				/>
				<SearchFormAddressBar
					rootClassName={styles.inputContainer}
					className={styles.input}
					type="text"
					placeholder="Inserisci una posizione"
					inputValue={endInputValue}
					value={endInputValue}
					onInputChange={handleEndInputChange}
					onSubmit={onEndSubmit}
					focusOnMount={false}
				/>
				<div
					className={styles.iconContainer}
					onClick={() => swapStartEndAddress()}
				>
					<Icon textOn="right" icon="icon/arrow_up_down_white.png" />
				</div>
			</div>
			<div className={styles.badgeContainer}>
				<div onClick={() => showTravelMode(TRAVEL_MODES.DRIVING)}>
					<Badge
						className={styles.badge}
						size={BadgeSizes.MEDIUM}
						variant={
							travelMode === TRAVEL_MODES.DRIVING
								? BadgeStyles.SECONDARY
								: BadgeStyles.PRIMARY
						}
						text={
							<>
								<Icon
									icon={
										travelMode === TRAVEL_MODES.DRIVING
											? 'icon/car_map_blue.png'
											: 'icon/car_map_white.png'
									}
									textOn="right"
								/>
								<small>
									{getTravelDuration(TRAVEL_MODES.DRIVING)}
								</small>
							</>
						}
					/>
				</div>
				<div onClick={() => showTravelMode(TRAVEL_MODES.TRANSIT)}>
					<Badge
						className={styles.badge}
						size={BadgeSizes.MEDIUM}
						variant={
							travelMode === TRAVEL_MODES.TRANSIT
								? BadgeStyles.SECONDARY
								: BadgeStyles.PRIMARY
						}
						text={
							<>
								<Icon
									icon={
										travelMode === TRAVEL_MODES.TRANSIT
											? 'icon/train_blue.png'
											: 'icon/train_white.png'
									}
									textOn="right"
								/>
								<small>
									{getTravelDuration(TRAVEL_MODES.TRANSIT)}
								</small>
							</>
						}
					/>
				</div>
				<div onClick={() => showTravelMode(TRAVEL_MODES.WALKING)}>
					<Badge
						className={styles.badge}
						size={BadgeSizes.MEDIUM}
						variant={
							travelMode === TRAVEL_MODES.WALKING
								? BadgeStyles.SECONDARY
								: BadgeStyles.PRIMARY
						}
						text={
							<>
								<Icon
									icon={
										travelMode === TRAVEL_MODES.WALKING
											? 'icon/walk_blue.png'
											: 'icon/walk_white.png'
									}
									textOn="right"
								/>
								<small>
									{getTravelDuration(TRAVEL_MODES.WALKING)}
								</small>
							</>
						}
					/>
				</div>
				{isMobile ? (
					<FloatingToggleButton
						className={styles.closeButton}
						show={true}
						onClick={onCalcRouteClose}
						enabled={true}
						icon={<Icon icon="icon/close_white.png" size="small" />}
						right={'10px'}
						top={'-5px'}
					/>
				) : null}
			</div>
		</div>
	);
}
